// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"header-search-result_searchResult__3Ifmr","resultName":"header-search-result_resultName__3crXy","resultType":"header-search-result_resultType__qVKZy"};